module.exports = __webpack_public_path__ + "img/step-four-icon.ad60c3a2.jpg";